import React, { Dispatch, SetStateAction } from "react"
import { Order, OrderHistory } from "lib/types/generated/graphql-types"
import { Cancellations } from "../../../../classes/order/Cancellations"
import PendingCancellation from "./PendingCancellation"
import FailedCancellation from "./FailedCancellation"
import OngoingCancellation from "./OngoingCancellation"

type Props = {
  order: Order
  refetch: () => void
  orderHistory: OrderHistory
  setShowCancelPopup: Dispatch<SetStateAction<boolean>>
}

const CancelOrder = ({ order, refetch, orderHistory, setShowCancelPopup }: Props) => {
  const cancellations = new Cancellations(order.Cancellations)
  return (
    <>
      {cancellations.ongoing() && (
        <PendingCancellation
          pendingCancellation={cancellations.getOngoingCancellation()}
          orderRefetch={refetch}
        />
      )}
      {cancellations.failed() && (
        <FailedCancellation
          failedCancellation={cancellations.getFailedCancellation()}
          orderId={order.id}
          refetch={refetch}
          orderHistory={orderHistory.history}
        />
      )}
      {cancellations.pending() && (
        <OngoingCancellation
          setShowCancelPopup={setShowCancelPopup}
          ongoingCancellation={cancellations.getPendingCancellation()}
        />
      )}
    </>
  )
}

export default CancelOrder
